import executeServerApi from 'assets/utils/server/ServerApi';
import { getDefaultHeaders, HttpMethod } from 'config/Api.Config';

type Request = Api.Sales.ContractRefundComment.List.IRequest;
type Response = Api.Sales.ContractRefundComment.List.IResponse;
type Headers = Api.Sales.ContractRefundComment.List.IHeaders;
const url = '/api/Sales/ContractRefundComment';
export default async function contractRefundCommentListApi(body?: Request): Promise<Api.Res<Response>> {
  return await executeServerApi<Request, Response, Headers>({
    method: HttpMethod.get,
    url,
    body,
    headers: getDefaultHeaders(),
  });
}
